export const GET_ALL_AIRLIENS_STATE = {
  success: 'get all airlines success',
  faild: 'get all airlines faild',
};
